import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Storage } from '@ionic/storage';

@Injectable()
export class StorageService {
  private paranoid = false;

  constructor(private storage: Storage) {
    this.storage.get('__wus').then(val => {
      if (!val && this.paranoid) {
        this.storage.set('__wus', CryptoJS.lib.WordArray.random(20).toString());
        console.log('Entrando en el cosntructor del StorageService');
      } else {
        console.log('NO entrando en el cosntructor del StorageService');
      }
    });
  }

  async has(name: string) {
    console.log('async has Name ', name);
    return await this.storage.get(name);
  }

  async get(name: string) {
    console.log('async get Name ', name);
    if (name === '__wus') return await this.storage.get('__wus');

    var response = await this.storage.get(name);
    console.log('Storage service get ', response);
    var getName = await this.storage.get(name);
    console.log('Storage service get Name ', getName);

    if (this.paranoid) {
      response = CryptoJS.AES.decrypt(
        await this.storage.get(name),
        await this.storage.get('__wus')
      );
      response = response.toString();
      console.log('Response paranoid ', response);
    }

    if (getName) {
      try {
        return JSON.parse(response);
      } catch (e) {
        return response;
      }
    } else {
      return undefined;
    }
  }

  async set(name: string, value: any) {
    console.log('Storage service set Name ', name, ' value ', value, ' parnoid ', this.paranoid);
    if (typeof value === 'object') value = JSON.stringify(value);

    if (this.paranoid) value = CryptoJS.AES.encrypt(value, await this.storage.get('__wus'));

    console.log('Storage Service set value ', value);
    var store = await this.storage.set(name, value);
    console.log('Storage Service get name ', name, ' store ', store);
    return this.get(name);
  }
}



// WEBPACK FOOTER //
// ./src/services/storage.service.ts